
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M348.832 428.544c-14.208 0-27.52-3.328-38.528-10.048-8.8-5.12-16.544-13.824-19.616-22.112-3.072-8.448-2.752-25.728-2.752-55.296V223.84h128.096v-95.808H287.936V0h-82.528c-3.328 26.336-9.312 48.192-18.112 65.088-8.416 17.216-20.256 31.776-34.24 44.096-14.464 12.192-36.864 21.504-57.088 28.128v72.544h68.704V389.28c0 23.52 2.368 41.472 7.424 53.728 4.96 12.352 13.44 23.968 26.4 34.848 12.736 11.008 27.968 19.456 46.176 25.408C262.4 509.12 276.352 512 299.808 512c20.576 0 39.808-1.952 57.408-6.272 17.632-4 36.8-10.08 58.816-20.352v-76.96c-25.728 16.8-41.248 20.128-67.2 20.128z"}})])
          )
        }
      }
    